export const collection = 'dentition';
export const productPath = 'product_image';
export const carcaseCollection = 'cms_carcase_category';
export const carcaseSubCollection = 'cms_carcase_subcategory';
